module.exports = __webpack_public_path__ + "img/hgai-banner.5f468312.png";